import { createSelector } from '~/helpers/util/selectors';
import { DeliveryPatternCreateState } from './duck';

export const getRoot = (state: any) => {
  return state.ui.deliveryPatternCreate as DeliveryPatternCreateState;
};
export const getModalClose = createSelector(getRoot, state => state.closeModal);
